import {createRoot, hydrateRoot} from 'react-dom/client';
import Scholarships from '../pages/Scholarships/Scholarships'
import "../index.css";
import "../pages/Scholarships/Scholarships.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<Scholarships {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <Scholarships {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ScholarshipsVC = {mount, hydrate, unmount}